export enum PersonType {
  Parent = 1,
  Child,
  OtherParent,
}
